import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const EMPTY_FORM = { saJson: "", subject: "", primary: "", rua: "" };

/** State + server actions for the network-wide Google Workspace credentials block. */
export function useGwsSettings() {
  const [cfg, setCfg] = useState(null);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState(EMPTY_FORM);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  async function load() {
    try { const r = await api.get("/gws/config"); setCfg(r.data); }
    catch (e) { setCfg({ configured: false, error: e.response?.data?.detail || e.message }); }
  }
  useEffect(() => { load(); }, []);

  async function run(fn) {
    setBusy(true); setErr(""); setMsg("");
    try { await fn(); }
    catch (e) { setErr(e.response?.data?.detail || e.message); }
    finally { setBusy(false); }
  }

  const save = () => run(async () => {
    const r = await api.put("/gws/config", {
      service_account_json: form.saJson.trim(), subject: form.subject.trim(),
      primary_domain: form.primary.trim() || null, dmarc_rua: form.rua.trim() || null,
    });
    setCfg(r.data); setEditing(false); setForm((f) => ({ ...f, saJson: "" }));
    setMsg(`Connected · ${r.data.probe?.domains_count ?? 0} domain(s) visible · primary ${r.data.primary_domain || "?"}`);
  });

  function remove() {
    if (!window.confirm("Remove the Google Workspace service account from this network? Sites already connected keep their DNS but can't verify/connect until re-added.")) return;
    run(async () => { await api.delete("/gws/config"); await load(); setMsg("Credentials removed"); });
  }

  function startEdit() {
    setEditing(true);
    setForm((f) => ({ ...f, subject: cfg.subject || "", primary: cfg.primary_domain || "", rua: cfg.dmarc_rua || "" }));
  }
  function cancelEdit() { setEditing(false); setErr(""); }
  const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const probe = cfg?.probe;
  const state = !cfg ? "checking" : !cfg.configured ? "off" : probe?.ok ? "live" : "error";

  return { cfg, probe, state, editing, form, setField, busy, msg, err, load, save, remove, startEdit, cancelEdit };
}
